/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * inojin-stg-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * ソーシャルログインのプロバイダー
Google, Facebook, LINEのいずれか
 */
export type PatientSocialLoginCallbackBodiesProvider = typeof PatientSocialLoginCallbackBodiesProvider[keyof typeof PatientSocialLoginCallbackBodiesProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientSocialLoginCallbackBodiesProvider = {
  Google: 'Google',
  Facebook: 'Facebook',
  LINE: 'LINE',
} as const;
